import React from '../../vendor/react';
import { useState } from '../../vendor/react';
import { LockKeyhole } from '../../vendor/lucide-react';
import { currentSearch, Link, navigate } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../features/auth/auth-store';
import { isStrongPassword } from '../../features/auth/validation';

export function ResetPasswordPage() {
  const auth = useAuth();
  const token = new URLSearchParams(currentSearch()).get('token') ?? '';
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const submit = async (event: SubmitEvent) => {
    event.preventDefault();
    setError('');
    const data = new FormData(event.currentTarget as HTMLFormElement);
    const password = String(data.get('password') ?? '');
    const confirmation = String(data.get('confirmation') ?? '');
    if (!token) return setError('El enlace de recuperación no es válido.');
    if (!isStrongPassword(password)) return setError('Usa mínimo 8 caracteres, mayúscula, minúscula y número.');
    if (password !== confirmation) return setError('Las contraseñas no coinciden.');
    try {
      await auth.actions.resetPassword(token, password);
      setDone(true);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'No se pudo cambiar la contraseña.');
    }
  };
  return (
    <AuthLayout eyebrow="Nueva contraseña" title={done ? 'Contraseña actualizada' : 'Protege tu cuenta'} description={done ? 'Ya puedes iniciar sesión con la nueva contraseña.' : 'Elige una contraseña diferente a la anterior.'}>
      {error && <AuthNotice tone="error">{error}</AuthNotice>}
      {done ? <><AuthNotice tone="success">El cambio quedó guardado correctamente.</AuthNotice><Button size="lg" className="full-width" onClick={() => navigate('/ingresar', { replace: true })}>Ir al acceso</Button></> : (
        <form className="auth-form" onSubmit={submit}>
          <label className="auth-field"><span>Nueva contraseña</span><div><LockKeyhole size={18} /><input name="password" type="password" autoComplete="new-password" required /></div></label>
          <label className="auth-field"><span>Confirmar contraseña</span><div><LockKeyhole size={18} /><input name="confirmation" type="password" autoComplete="new-password" required /></div></label>
          <Button type="submit" size="lg" className="full-width">Guardar contraseña</Button>
        </form>
      )}
      {!done && <p className="auth-card__footer"><Link to="/ingresar">Cancelar</Link></p>}
    </AuthLayout>
  );
}
